import React from "react";

export const CylinderProgress3Divide = ({ data }) => {
  const total = data[0]?.total_points ?? 0;
  const used = data[0]?.used_points ?? 0;
  const balanced = data[0]?.balanced_points ?? 0;
  const expired = data[0]?.expired_points; // keep undefined if not present

  // Calculate percentages
  const usedPct = total > 0 ? (used / total) * 100 : 0;
  const balancedPct = total > 0 ? (balanced / total) * 100 : 0;
  const expiredPct = total > 0 && expired ? (expired / total) * 100 : 0;

  return (
    <div className="w-full">
      {/* Progress Bar */}
      <div className="text-xs font-[400] text-gray-700 mb-1">
        Total: {total}
      </div>
      <div className="relative w-full h-4 rounded-full overflow-hidden flex bg-gray-200">
        <div
          className="h-full bg-blue-500"
          title={used}
          style={{ width: `${usedPct}%` }}
        />
        <div
          className="h-full bg-green-500"
          title={balanced}
          style={{ width: `${balancedPct}%` }}
        />
        {expired !== undefined && (
          <div
            className="h-full bg-red-500"
            title={expired}
            style={{ width: `${expiredPct}%` }}
          />
        )}
      </div>

      {/* Labels Below */}
      <ul className="flex justify-between mt-2 text-xs text-gray-700">
        <li>Used: {used}</li>
        <li>Balanced: {balanced}</li>
        {expired !== undefined && <li>Expired: {expired}</li>}
      </ul>
    </div>
  );
};
